<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.domain.update")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineDomainForm :APIbaseURL="APIbaseURL" :domain="domain" :invitation="invitation" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineDomainForm } from 'aveine-domain'
import { Domain, Invitation } from 'aveine-toolbox'
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      domain: {},
      invitation: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineDomainForm
  },
  async created() {
    try {
      await Domain.api().get(`domains/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
          params: {
            include:
            'region,' +
            'address.spatial-information,address.country',
          }
        }
      );

      let invitations = await Invitation.api().get(`invitations?lang=${this.$i18n.locale}?lang=${this.$i18n.locale}`, {
        params: {
          "filter[entityId]": this.$route.params.id,
          include: 'user'
        }
      })

      this.domain = await Domain.query().whereId(this.$route.params.id).withAllRecursive().first();
      if (invitations.entities.invitations) {
        this.invitation = await Invitation.query().whereId(invitations.entities.invitations[0].id).withAllRecursive().first()
      } else {
        let invitation = await Invitation.new()
        this.invitation = Invitation.query().whereId(invitation.id).withAllRecursive().first()
        this.invitation. $isNew = true;
      }


      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  }
}
</script>
